"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Instagram } from "lucide-react";
export default function NojnojsupplyyFooter() {
  return <footer data-section-id="225592" id="footer" className="bg-[#09080A] text-[#F5F0FF] pt-24 pb-24 px-6 md:px-12 text-[11px] tracking-[0.15em] uppercase font-default selection:bg-[#C48A3A] selection:text-[#09080A] border-t border-[#C48A3A]/10">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-start">
          
          {}
          <div className="flex flex-col gap-6">
            <Link to="https://terrigma.com" newTab className="inline-block w-fit group">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1649185/img/terrigma_gold_wordmark.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1649185/img/terrigma_gold_wordmark.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1649185/img/terrigma_gold_wordmark.png-wvc-sizes" alt="TERRIGMA" className="h-7 w-auto object-contain transition-opacity duration-300 group-hover:opacity-80" loading="lazy" />
            </Link>
            <div className="space-y-2">
              <p className="text-[#C48A3A] font-serif text-sm tracking-[0.2em] font-bold">
                DIG THE WORLD. COLLECT THE EARTH.
              </p>
              <p className="text-[#F5F0FF]/60 normal-case tracking-normal font-default max-w-xs">
                The world's first mobile soil science exploration game.
              </p>
            </div>
            <div className="pt-2">
              <Link to="https://instagram.com/terr_igma" newTab className="flex items-center gap-2 text-[#C48A3A] hover:text-[#C9B8F5] transition-colors duration-300 w-fit">
                <Instagram size={16} strokeWidth={1.5} />
                <span className="text-[10px] font-semibold tracking-widest">@TERR_IGMA</span>
              </Link>
            </div>
          </div>

          {}
          <div className="flex flex-col md:items-end gap-8 md:text-right">
            <div className="space-y-4">
              <div>
                <h4 className="text-[#C9B8F5] mb-1 font-semibold tracking-widest">DATA SOURCE</h4>
                <p className="text-[#F5F0FF]/80 normal-case tracking-normal font-mono text-[10px]">
                  Science data: FAO World Soil Database + ISRIC
                </p>
              </div>
              
              <div className="pt-4 border-t border-[#C9B8F5]/10">
                <p className="text-[#F5F0FF]/40 normal-case tracking-normal flex flex-col md:items-end gap-1">
                  <span>&copy; 2026 Terrigma. All rights reserved.</span>
                  <Link to="mailto:contact@terrigma.com" className="text-[#F5F0FF]/60 hover:text-[#C48A3A] transition-colors duration-300">Email: contact@terrigma.com</Link>
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </footer>;
}